import axios from '@/axios'

const getSchedules = async ({commit, rootState}, reset = false) => {
  const accountId = rootState.global.account.id
  if (reset) commit('SET_SCHEDULES', [])
  const { data } = await axios.get(`/v1/schedules?accountId=${accountId}`)
  commit('SET_SCHEDULES', data)
}

export default {
  getSchedules
}
